"use client";
import { useContext, useEffect } from "react";

import { JuneSoContext } from "@stadium/services/june-analytics/provider";

export const useJuneSo = ({ defaults = {} } = {}) => {
  const contextParams = useContext(JuneSoContext);
  const { setPageName } = contextParams;

  useEffect(() => {
    if (defaults?.pageName) {
      setPageName(defaults?.pageName);
      return () => setPageName("");
    }
  }, []);

  return contextParams;
};
